import React, { Component } from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import LoggedOutLayout from './layouts/LoggedOut'
import LoggedInLayout from './layouts/LoggedIn'
import Login from './routes/Login'
import Room from './routes/Room'
import WebinarRoom from './routes/Room/WebinarRoom'
import Users from './routes/Users'
import ActivityLogs from './routes/ActivityLogs'
import EmailAddressBook from './routes/EmailAddressBook'
import Invitations from './routes/Invitations'
import News from './routes/News'
import Settings from './routes/Settings'
import ResetPassword from './routes/ResetPassword'
import Domain from './routes/Domain'
import DomainCreate from './routes/Domain/create'
import SignUp from './routes/SignUp';
import DomainLayout from './layouts/Domain'
import ManagePlans from './routes/ManagePlans'
import ManageIpAddress from './routes/ManageIpAddress'
import Billings from './routes/Billings'
import RoomRecordings from './routes/RoomRecordings'
import Transcriptions from './routes/Transcriptions'
import TranscriptionInfo from './routes/Transcriptions/TranscriptionInfo'
import GroupedTranscriptions from './routes/Transcriptions/GroupedTranscriptions'
import Questionnaire from './routes/Questionnaire'
import ProblemReports from './routes/ProblemReports'
import ProblemReportsDetails from './routes/ProblemReports/ProblemReportsDetails'

// All the routes of our app
class Routes extends Component {

  render() {
    let domainRoute = `/fvdomain`
    return (
      <Router>
        <Switch>
          {/* Routes and the layouts for a logged out user */}

          <News path="/edit_news" exact/>
          <DomainLayout path={`${domainRoute}/problem-reports`} component={ProblemReports} exact/>
          <DomainLayout path={`${domainRoute}/problem-reports-details`} component={ProblemReportsDetails} exact/>
          <DomainLayout path={`${domainRoute}/create`} component={DomainCreate} exact/>
          <DomainLayout path={`${domainRoute}/:id`} component={DomainCreate} exact/>
          <DomainLayout path={`${domainRoute}`} component={Domain} exact/>

          {/* <LoggedInLayout path="/" exact component={Room}/> */}
          <LoggedInLayout path="/settings" component={Settings}/>
          <LoggedInLayout
            path="/admin/settings/manage-plans/:campaign?"
            exact
            component={ManagePlans}
          />
          <LoggedInLayout
            path="/admin/settings/ip-addresses"
            exact
            component={ManageIpAddress}
          />
          <LoggedInLayout path="/admin" exact component={Room}/>
          <LoggedInLayout path="/admin/webinar" exact component={WebinarRoom}/>
          <LoggedInLayout path="/admin/invoices" exact component={Billings}/>
          <LoggedInLayout path="/admin/users" component={Users}/>
          <LoggedInLayout path="/admin/questionnaires" component={Questionnaire}/>
          <LoggedInLayout path="/admin/transcriptions" component={Transcriptions}/>
          <LoggedInLayout path="/admin/transcription-info" component={TranscriptionInfo}/>
          <LoggedInLayout path="/admin/email-address-book" component={EmailAddressBook}/>
          <LoggedInLayout path="/admin/invitations" component={Invitations}/>
          <LoggedInLayout path="/admin/transcription-group" component={GroupedTranscriptions}/>
          <LoggedInLayout path="/admin/calls/logs" exact component={ActivityLogs}/>
          <LoggedInLayout path="/admin/news" component={News}/>
          {/* <LoggedInLayout path="/admin/room_recordings" exact component={RoomRecordings}/> */}
          <LoggedInLayout path="/admin/settings" exact component={Settings}/>
          <LoggedOutLayout path="/login" component={Login}/>
          <LoggedOutLayout path="/signup" component={SignUp} />
          <LoggedOutLayout exact path="/forgot-password" component={Login}/>
          <LoggedOutLayout path="/password" component={ResetPassword}/>
          <LoggedOutLayout path="/change_email" component={ResetPassword}/>
          <LoggedOutLayout path="/activate" component={ResetPassword}/>
          <Route component={NoMatch}/>
        </Switch>
      </Router>
    )
  }
}

const NoMatch = ({location}) => {
  if (location.pathname.replace(/\//g, '') === "") {
    window.location=("admin");
  }
  else {
    window.setTimeout('window.location=("admin");', 3000)
  }
  return (
    <section className="flex items-center flex-column justify-center h-100 bg-washed-blue">
      {location.pathname.replace(/\//g, '') !== "" && <header class="tc ph5 lh-copy">
        <h1 className="f1 f-headline-l w-100 tc code mb3 fw9 dib tracked-tight light-purple">
          404
        </h1>
        <h2 className="tc f1-l fw1">
          指定されたページはみつかりません。３秒後にトップへ戻ります。 <code>{location.pathname}</code>
        </h2>
      </header> }
    </section>
  )
}

export default Routes



// WEBPACK FOOTER //
// src/Routes.js